module.exports = __webpack_public_path__ + "static/img/sy.06f8d748.png";